import {
  SET_SEND_MONEY_USER_INFO,
  SET_LOADING_STATUS,
  SET_PHONE_NUMBER,
  SET_VALID_SALES_CODE,
  SET_OOM_FLOW_ELIGIBILITY,
  SET_QRIS_USER_INFO,
  SET_QRIS_BLUE_BOX_FIRST_DATE,
  SET_HAS_PIN,
} from './mutationTypes';

export default {
  [SET_SEND_MONEY_USER_INFO]: (state, info) => {
    state.sendMoneyUserInfo = info;
  },
  [SET_LOADING_STATUS]: (state, status) => {
    state.loadingStatus = status;
  },
  [SET_PHONE_NUMBER]: (state, phone) => {
    state.phone = phone;
  },
  [SET_VALID_SALES_CODE]: (state, validSalesCode) => {
    state.validSalesCode = validSalesCode;
  },
  [SET_OOM_FLOW_ELIGIBILITY]: (state, oomFlowEligibility) => {
    state.oomFlowEligibility = oomFlowEligibility;
  },
  [SET_QRIS_USER_INFO]: (state, info) => {
    state.qrisUserInfo = info;
  },
  [SET_QRIS_BLUE_BOX_FIRST_DATE]: (state, firstDate) => {
    state.qrisBlueBoxFirstDate = firstDate;
  },
  [SET_HAS_PIN]: (state, hasPIN) => {
    state.hasPIN = hasPIN;
  },
};
